import type { ReactNode } from "react";
import { AnimatePresence, styled } from "tamagui";
import { YStack } from "../Stacks";
import { presenceTransition } from "./motion";
import { PresenceSlot } from "./PresenceSlot";
const SLIDE_OFFSET = 48;
export type SlideTransitionProps = {
  stateKey: string;
  /** +1 forward, -1 back. */
  direction: 1 | -1;
  children: ReactNode;
};

// `direction` reaches the frame through AnimatePresence's `custom`, so a
// leaving screen exits in the direction of the swap that removed it, not the
// one it arrived on.
const Frame = styled(YStack, {
  flex: 1,
  opacity: 1,
  transition: presenceTransition,
  animateOnly: ["opacity", "transform"],
  variants: {
    slide: {
      ":number": (direction: number) => ({
        enterStyle: {
          opacity: 0,
          x: direction * SLIDE_OFFSET
        },
        exitStyle: {
          opacity: 0,
          x: -direction * SLIDE_OFFSET
        }
      })
    }
  } as const
});

/** Keyed screen swap: the leaving screen slides out over the arriving one. */
export const SlideTransition = ({
  stateKey,
  direction,
  children
}: SlideTransitionProps) =>
// Its own box, so a leaving screen is placed against it and not against a
// padded parent, where an absolute frame would sit over the padding.
<YStack flex={1} data-sentry-element="YStack" data-sentry-component="SlideTransition" data-sentry-source-file="SlideTransition.tsx">
    <AnimatePresence initial={false} custom={{
    slide: direction
  }} data-sentry-element="AnimatePresence" data-sentry-source-file="SlideTransition.tsx">
      <PresenceSlot key={stateKey} flex data-sentry-element="PresenceSlot" data-sentry-source-file="SlideTransition.tsx">
        <Frame slide={direction} data-sentry-element="Frame" data-sentry-source-file="SlideTransition.tsx">{children}</Frame>
      </PresenceSlot>
    </AnimatePresence>
  </YStack>;